import { Components } from '@mui/material';
import { BODY1_LINE_HEIGHT } from '../watchdutyTheme.utils';

export const MuiDialogContentText: Components['MuiDialogContentText'] = {
  styleOverrides: {
    root: {
      fontSize: 'var(--mui-typography-body1-fontSize)',
      lineHeight: BODY1_LINE_HEIGHT,
    },
  },
};
